// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const ProjectIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg width={width} height={height} viewBox="0 0 24 21" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.5 4.5H18V3C18 1.35 16.65 0 15 0H9C7.35 0 6 1.35 6 3V4.5H1.5C0.675 4.5 0 5.175 0 6V19.5C0 20.325 0.675 21 1.5 21H22.5C23.325 21 24 20.325 24 19.5V6C24 5.175 23.325 4.5 22.5 4.5ZM7.5 3C7.5 2.175 8.175 1.5 9 1.5H15C15.825 1.5 16.5 2.175 16.5 3V4.5H7.5V3ZM22.5 19.5H1.5V6H22.5V19.5Z" fill="inherit"/>
          <path d="M12 8.25L6.83437 15.75H17.1656L12 8.25Z" fill="inherit"/>
        </svg>
      )
    }
  </Icon>
);

export default ProjectIcon;
